export default __webpack_public_path__ + "static/media/boxtype2.6fd23853.JPG";